<template>
  <div class="jobs">
    <h1>Pending/Active Jobs</h1>
    <div class="table-wrapper loader-container">
      <vue-good-table
        v-if="jobs"
        :columns="[
          {
            label: 'Customer',
            field: 'customerComponent.customer.customerName'
          },
          {
            label: 'Component',
            field: 'customerComponent.component.componentName'
          },
          {
            label: 'Action',
            field: 'action'
          },
          {
            label: 'Date Created',
            field: 'dateCreated',
            formatFn: formatDateTime
          },
          {
            label: 'Created By',
            field: 'createdBy'
          },
          {
            label: 'Date Run',
            field: 'dateRun',
            formatFn: formatDateTime
          },
          {
            label: 'Run By',
            field: 'runBy'
          },
          {
            label: 'Date Completed',
            field: 'dateCompleted',
            formatFn: formatDateTime
          },
          {
            label: 'Date Failed',
            field: 'dateFailed ',
            formatFn: formatDateTime
          },
          {
            label: 'Error',
            field: 'error'
          }
        ]"
        :rows="jobs"
      ></vue-good-table>
      <Loader :loading="loadingJobs" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Loader, VueGoodTable },
  data() {
    return {
      jobs: []
    };
  },
  created() {
    this.getJobs();
  },
  methods: {
    getJobs() {
      var self = this;
      self.loadingJobs = true;
      service
        .getJobs()
        .then(response => {
          self.jobs = response.data;
          self.loadingJobs = false;
        })
        .catch(() => {
          self.loadingJobs = false;
        });
    }
  }
};
</script>
